export const APP_PREFIX = 'APP';

export const TUTORIAL_PREFIX = 'TUTORIAL';

export const COURSE_PREFIX = 'COURSE';

export const INTERVAL_EXERCISE_PREFIX = 'INTERVAL_EXERCISE';

export const EXERCISE_PREFIX = 'EXERCISE';

export const KEYBOARD_INTERFACE_PREFIX = 'KEYBOARD_INTERFACE';

export const SEQUENCER_INTERFACE_PREFIX = 'SEQUENCER_INTERFACE';
